import React from 'react';

import { Link } from '@mui/material';
import { observer } from 'mobx-react';

import classes from './NgzEntityStatusInfo.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { useStatusDetails } from './hooks/useStatusDetails';
import { useEntityTaxUpdate } from '../../../payment';
import { getNeedToSetupInfo } from './utils/getNeedToSetupInfo';
import { pathQueryParams } from '../../../shared/constants/pathQueryParams';
import { ENTITY_PROFILE_TAB_NAME } from '../../../shared/constants/tabNames/ENTITY_PROFILE_TAB_NAME';
import { solutionsStore } from '../../../shared/stores/solutionsStore';
import { SolutionType } from '../../../shared/constants/user-info/solutionType';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';

type EntityStatusInfoProps = {
  solution: SolutionType;
};

const EntityStatusInfo = observer(({ solution }: EntityStatusInfoProps) => {
  const { unconfigured, getStatusDetails } = useStatusDetails(solution);

  useEntityTaxUpdate(solution, () => getStatusDetails());

  const isHideStatusInfo = !unconfigured.length;

  if (isHideStatusInfo) {
    return null;
  }

  const needToSetupInfo = getNeedToSetupInfo(unconfigured);

  return (
    <div className={classes.box}>
      <p>
        To activate your profile and make your coaching services available to potential
        clients, please {needToSetupInfo}
      </p>
      <Link
        href={`#!/entity-profile?${pathQueryParams.initialTabName}=${ENTITY_PROFILE_TAB_NAME.PAYMENT}`}
        className={classes.link}
      >
        Open Payment tab
      </Link>
    </div>
  );
});

const NgzEntityStatusInfo = observer(() => {
  const { activeSolution } = solutionsStore;
  const { isEntity, paymentFlowType } = loggedInUserDataStore;

  const isGetStatusDetailsAllowed =
    isEntity && paymentFlowType.NEW_USER_FLOW_2024 && activeSolution;

  if (!isGetStatusDetailsAllowed) {
    return;
  }

  return <EntityStatusInfo solution={activeSolution} />;
});

angularizeWithProviders(NgzEntityStatusInfo, 'ngzEntityStatusInfo', {});

export { NgzEntityStatusInfo };
